<template>
  <section class="section dashboard">
    <div class="row">
      <div class="col-lg-12">
        <draggable
            v-model="categoriesCards"
            item-key="id"
            tag="div"
            class="row"
            handle=".drag-handle"
            @end="emit('drag', categoriesCards)"
        >
          <template #item="{ element: cat }">
            <div class="col-xxl-2 col-md-6 mb-4">
              <div class="card info-card revenue-card w-100 h-100">

                <div class="filter d-flex align-items-center">
                    <span class="drag-handle me-2" style="cursor: grab;">
                      <i class="bi bi-grip-vertical"></i>
                    </span>

                  <ActionDropdown>
                    <li class="dropdown-header text-start">
                      <h6>Действия</h6>
                    </li>
                    <li>
                      <a
                          @click.prevent="onUpdate(cat)"
                          class="dropdown-item"
                          href="#"
                      >Изменить</a>
                    </li>
                    <li>
                      <a
                          @click.prevent="onDelete(cat)"
                          class="dropdown-item"
                          href="#"
                      >Удалить</a>
                    </li>
                  </ActionDropdown>
                </div>

                <div class="card-body g-3 mt-3 d-flex justify-content-center align-items-center">
                  <h5 class="card-title">{{ cat.name }}</h5>
                </div>
              </div>
            </div>
          </template>
        </draggable>

        <div class="row">
          <div class="col-xxl-2 col-md-6 mb-4">
            <div
                class="card info-card add-card w-100 h-100 d-flex align-items-center justify-content-center"
                @click="emit('add')"
                style="cursor: pointer;"
            >
              <div class="text-center">
                <h5 class="card-title">
                  <i class="bi bi-plus-lg" style="font-size: 48px;"></i>
                  <br>
                  Добавить
                </h5>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import {ref, onMounted, onUnmounted, watch} from 'vue';
import draggable from 'vuedraggable';
import ActionDropdown from "@/components/ui/components/ActionDropdown.vue";

const props = defineProps({
  categories: { type: Array, required: true }
});

const categoriesCards = ref([]);
const buildCategoriesCards = async (categories) => {
  categoriesCards.value = [...categories];
}

watch(
    () => props.categories,
    (categories) => {
      return categories ? buildCategoriesCards(categories) : [];
    },
    { immediate: true, deep: true }
);

const emit = defineEmits(['update', 'delete', 'add', 'drag']);

function onUpdate(cat) {
  emit('update', cat);
}

function onDelete(cat) {
  emit('delete', cat);
}
</script>
